import axios from "axios";
import { toast } from "react-toastify"; // Import toast for notifications

// Set the baseURL to the appropriate API endpoint
const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = true;


// Request interceptor to add the token to headers
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    // List of API endpoints where token should NOT be included
    const excludedEndpoints = ["/User/UpdatePassword"];

    // Check if the request URL contains any excluded endpoint
    const shouldExcludeToken = excludedEndpoints.some((endpoint) =>
      config.url.includes(endpoint)
    );

    if (token && !shouldExcludeToken) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});
axiosInstance.interceptors.request.use(
  (config) => {
    const otpToken = localStorage.getItem("otpToken");
    const token = localStorage.getItem("token");
    const activeToken = otpToken || token;
    if (activeToken) {
      config.headers.Authorization = `Bearer ${activeToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors
axios.interceptors.response.use(
  (response) => response, // Return response if successful
  (error) => {
    if (error.response && error.response.status === 401) {
      // Show session expired message
      toast.error("Session expired. Please log in again.");

      // Clear local storage
      localStorage.clear();

      // Redirect to login page
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Function to login user
export const LoginApi = (inputs) => {
  const { username, password, privacyPolicyAccepted } = inputs;

  const LOGIN_URL = `/User/ValidateUserLogin/${username},${password}?privacyPolicy=${privacyPolicyAccepted}`;

  return axios.get(LOGIN_URL);
};


// Function to fetch visitor types
export const fetchVisitorTypes = async () => {
  const VISITOR_TYPES_URL = '/VisitorType';
  try {
    const response = await axios.get(VISITOR_TYPES_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching visitor types:', error);
    throw error;
  }
};
export const fetchVisitorTypesN = async () => {
  const VISITOR_TYPES_URL = '/VisitorType';
  try {
    const response = await axiosInstance.get(VISITOR_TYPES_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching visitor types:', error);
    throw error;
  }
};

// Function to fetch ID proof types
export const fetchIdProofTypes = async () => {
  const ID_TYPES_URL = '/idproof';
  try {
    const response = await axios.get(ID_TYPES_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching ID proof types:', error);
    throw error;
  }
};

// Function to fetch meeting venues
export const fetchMeetingVenues = async () => {
  const empId = localStorage.getItem("employeeId")
  const MEETING_VENUES_URL = `/Location/GetLocationByEmpId?empId=${empId}`;
  try {
    const response = await axios.get(MEETING_VENUES_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching meeting venues:', error);
    throw error;
  }
};

export const fetchNationality = async () => {
  const NATIONALITY_URL = '/Nationality';
  try {
    const response = await axios.get(NATIONALITY_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching meeting venues:', error);
    throw error;
  }
};

// Function to fetch gate details
export const fetchGateDetails = async () => {
  const GATE_DETAILS_URL = '/Location/GetAllGates';
  try {
    const response = await axios.get(GATE_DETAILS_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching gate details:', error);
    throw error;
  }
};

// Function to fetch buildings by gate ID
export const fetchBuildingsByGate = async (gateID) => {
  const BUILDINGS_BY_GATE_URL = '/Location/GetBuidingsByGateID';
  try {
    const response = await axios.get(BUILDINGS_BY_GATE_URL, {
      params: { gateID }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching buildings by gate ID:', error);
    throw error;
  }
};

// Function to insert an appointment
export const insertAppointment = async (formData) => {
  const APPOINTMENT_URL = '/Appointment';
  try {
    const response = await axios.post(APPOINTMENT_URL, formData);
    return response.data;
  } catch (error) {
    console.error('Error inserting appointment:', error);
    throw error;
  }
};

// Function to link mail and SMS
export const linkMailAndSms = async (appId) => {
  const MAILCONFIG_URL = `/Appointment/Linkmailandsms/${appId}`;
  try {
    const response = await axios.post(MAILCONFIG_URL);
    return response.data;
  } catch (error) {
    console.error('Error linking mail and SMS:', error);
    throw error;
  }
};

// Function to verify OTP
export const verifyOTP = async (otpCode, verificationType, emailId, mobileNo, visitorName, meetingVenue, createdOn, meetingOn, modifiedOn, hostName) => {
  const OTP_VERIFICATION_URL = '/EPassRegistration/OTPVerification';
  try {
    const response = await axiosInstance.put(OTP_VERIFICATION_URL, {
      otpValue: otpCode,
      verificationType: verificationType,
      emailId: emailId,
      mobileNo: mobileNo,
      visitorName: visitorName,
      meetingVenue: meetingVenue,
      createdOn: createdOn,
      meetingOn: meetingOn,
      modifiedOn: modifiedOn,
      hostName: hostName
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying OTP:', error);
    throw error;
  }
};

// Function to resend OTP
export const resendOtp = async () => {
  const RESEND_OTP_URL = '/EPassRegistration/SendOTP';
  try {
    const response = await axiosInstance.post(RESEND_OTP_URL);
    return response.data;
  } catch (error) {
    console.error('Error resending OTP:', error);
    throw error;
  }
};
export { axiosInstance };


export const GetCouriers = async () => {
  try {
    const response = await axios.get('/Courier/GetCouriers');
    return response.data;
  } catch (error) {
    console.error("Error updating courier:", error);
    throw error;
  }

}

// get Department
export const GetDepartment = async () => {
  try {
    const response = await axios.get('/Department');
    return response.data;
  } catch (error) {
    console.error("Error updating courier:", error);
    throw error;
  }

}


// Courier inward API 
export const GetInward = async (date) => {
  const selectedDate = date || new Date().toISOString().split('T')[0];
  const INWARD_COURIERS_URL = `/Courier/GetInwardCourierData/${selectedDate}`;

  try {
    const response = await axios.get(INWARD_COURIERS_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching inward couriers:', error);
    throw error;
  }
};


export const AddInwardCourier = async (inwardData) => {
  const ADD_INWARD_COURIER_URL = '/Courier/AddInwardCourier';

  try {
    const response = await axios.post(ADD_INWARD_COURIER_URL, inwardData, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}` // if authentication is needed
      }
    });

    console.log('Courier added successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error adding inward courier:', error);
    throw error;
  }
};

export const UpdateInwardCourier = async (formData) => {
  try {
    const response = await axios.put('/Courier/UpdateInwardCourier', formData);
    return response.data;
  } catch (error) {
    console.error("Error updating courier:", error);
    throw error;
  }
};


// Courier outward API 
export const GetOutward = async (date) => {
  const selectedDate = date || new Date().toISOString().split('T')[0];
  const OUTWARD_COURIERS_URL = `/Courier/GetOutwardCourierData/${selectedDate}`;

  try {
    const response = await axios.get(OUTWARD_COURIERS_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching outward couriers:', error);
    throw error;
  }
};

export const AddOutwardCourier = async (outwardData) => {
  const ADD_OUTWARD_COURIER_URL = '/Courier/AddOutwardCourier';

  try {
    const response = await axios.post(ADD_OUTWARD_COURIER_URL, outwardData, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}` // if authentication is needed
      }
    });

    console.log('Outward courier added successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error adding outward courier:', error);
    throw error;
  }
};

export const UpdateOutwardCourier = async (formData) => {
  const UPDATE_OUTWARD_COURIER_URL = '/Courier/UpdateOutwardCourier'; // ✅ correct endpoint

  try {
    const response = await axios.put(UPDATE_OUTWARD_COURIER_URL, formData);
    return response.data;
  } catch (error) {
    console.error('Error updating outward courier:', error);
    throw error;
  }
};




// get Employee key
export const GetEmployee = async () => {
  try {
    const response = await axios.get('/Employee/GetActiveEmployees');
    return response.data;
  } catch (error) {
    console.error("Error updating courier:", error);
    throw error;
  }
}

// Key Logs API 
export const GetKeyLogs = async (date, toBeReturned) => {
  const selectedDate = date || new Date().toISOString().split('T')[0];

  try {
    const response = await axios.get('/KeyLog/GetKeyLogsData', {
      params: {
        dateTime: selectedDate,
        toBeReturned: toBeReturned
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching key logs:', error);
    throw error;
  }
};

export const AddKeyLog = async (outwardData) => {
  const ADD_OUTWARD_COURIER_URL = '/KeyLog/AddKeyLog';

  try {
    const response = await axios.post(ADD_OUTWARD_COURIER_URL, outwardData, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}` // if authentication is needed
      }
    });

    console.log('Outward courier added successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error adding outward courier:', error);
    throw error;
  }
};

export const UpdateKeyLog = async (formData) => {
  const UPDATE_OUTWARD_COURIER_URL = '/KeyLog/UpdateKeyLog'; // ✅ correct endpoint

  try {
    const response = await axios.put(UPDATE_OUTWARD_COURIER_URL, formData);
    return response.data;
  } catch (error) {
    console.error('Error updating outward courier:', error);
    throw error;
  }
};

// get All key
export const GetAllKey = async () => {
  try {
    const response = await axios.get('/KeyLog/GetActiveKeys');
    return response.data;
  } catch (error) {
    console.error("Error updating courier:", error);
    throw error;
  }
}

// getStatusListByType
export const GetStatusListByType = async () => {
  try {
    const response = await axios.get('/StatusList/GetStatusListByType', {
      params: {
        type: 'key'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching status list by type:", error);
    throw error;
  }
};


// Key Master API

export const GetAllKeyData = async (id) => {
  try {
    const response = await axios.get('/KeyLog/GetAllKeysData', {
      params: { statusId: id }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching key data:", error);
    throw error;
  }
};

export const GetKeyStatus = async () => {
  try {
    const response = await axios.get('/StatusList/GetStatusListwithAll');
    return response.data;
  } catch (error) {
    console.error("Error updating courier:", error);
    throw error;
  }
}


export const AddKeyMaster = async (formData) => {
  try {
    const response = await axios.post('/KeyLog/AddKey', formData);
    return response.data;
  } catch (error) {
    console.error('Error adding key log:', error);
    throw error;
  }
};


export const UpdateKeyMaster = async (formData) => {
  try {
    const response = await axios.put('/KeyLog/UpdateKey', formData);
    return response.data;
  } catch (error) {
    console.error('Error updating key log:', error);
    throw error;
  }
};


//Courier Master API
export const GetAllCouriers = async () => {
  try {
    const response = await axios.get('/Courier/GetCouriers');
    return response?.data;
  } catch (error) {
    console.error('Error Get All Couriers:', error);
    throw error;
  }
}

export const AddCourierMaster = async (formData) => {
  try {
    const response = await axios.post('/Courier/AddCourier', formData);
    return response?.data;
  } catch (error) {
    console.error('Error Add Courier:', error);
    throw error;
  }
}

export const UpdateCourierMaster = async (formData) => {
  try {
    const response = await axios.put('/Courier/UpdateCourier', formData);
    return response?.data;

  } catch (error) {
    console.error('Error Update Courier:', error);
    throw error;
  }
}

